<template>
<div id="ABM820">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
        <img id="photo" src="./img/ABM820/820_1.png"/>
      </div>
      <div id="desc" class="col-sm-12 col-md-12 col-lg-8 col-xl-8">
        <!-- <div><h2 style="color: #00aeff">{{msg}}</h2></div> -->
        <p class="text">
          {{text}}
        </p>
        <table >
          <table style="margin:0 auto;">
            <thead>
              <tr>
                <th v-for="item in NameTableSecond">{{item}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in item_table">
                <td :colspan="item.value ? 1 : 2">{{item.name}}</td>
                <td v-if="item.value">{{item.value}}</td>
              </tr>
            </tbody>
          </table>
        </table>
      </div>
    </div>
  </div>
    <div id="nineteen">

    </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      msg: 'Опорно-поворотное устройство астросиб АВМ 820',
      text: 'Объектив представляет собой малоапертурный катадиоптрический широкопольный оптический прибор высокой светосилы со сферической оптикой, который выполнен по системе Шенкера с трехлинзовым полноапертурным корректором, с задним расположением фотоприёмного устройства в фокусе Кассегрена. Компоновка  и применённая оптическая схема  позволяют  использовать фотоприёмную аппаратуру произвольных габаритов и, в силу размещения вторичного зеркала на линзе полноапертурного корректора, избежать применения системы механических конструктивных элементов крепления вторичного зеркала - растяжек, что исключает помехи от них на изображении, и позволяет эффективно обнаруживать слабые точечные объекты вблизи ярких источников света (звезд) в поле зрения.',
      NameTableSecond: ['Параметры и характеристики (свойства)', 'Показатели (значения)'],
      item_table:[
				{
					name: 'Максимальная грузоподъёмность (полезная нагрузка в виде оптического модуля (модулей) с оборудованием), кг',
					value: '200'
				},
				{
					name: 'Диапазон угловых перемещений по азимуту, град',
					value: 'от 0 до плюс 355'
				},
				{
					name: 'Диапазон угловых перемещений по высоте, град',
					value: 'от минус 5 до плюс 100'
				},
				{
					name: 'Диапазон угловых скоростей в режиме «наведение» по азимуту, град/с',
					value: 'от 0 до плюс 10'
				},
				{
					name: 'Диапазон угловых скоростей в режиме «наведение» по высоте, град/с',
					value: 'от 0 до плюс 10'
				},
				{
					name: 'Точность позиционирования, не более, град',
					value: '0.01'
				},
				{
					name: 'Угловая скорость по азимуту:',
					value: ''
				},
				{
					name: '-  режим «целеуказание», от угл.с/c до град/с ',
					value: 'по функционалу, в диапазоне от 0,2 до 10'
				},
				{
					name: '- режим «автономный поиск», град/сек',
					value: '0'
				},
				{
					name: 'Угловая скорость по высоте:',
					value: ''
				},
				{
					name: '-  режим «целеуказание», от угл.с/c до град/с',
					value: 'по функционалу, в диапазоне от 0,2 до 10'
				},
				{
					name: '- режим «автономный поиск», град/сек',
					value: '0'
				},
				{
					name: 'Угловая ошибка сопровождения ОКО в режиме «целеуказание» на временном интервале 100сек во всём диапазоне угловых скоростей, не более, угл.с',
					value: ''
				},
				{
					name: '- полная амплитуда',
					value: '3'
				},
				{
					name: '- RMS',
					value: '0.2'
				},
				{
					name: 'Диапазон регулировки азимутального положения ОПУ в сборе, град',
					value: '±5'
				},
				{
					name: 'Диапазон регулировки вертикального положения ОПУ с сборе, град',
					value: '±2'
				},
				{
					name: 'Допустимая точность юстировки ОПУ-65 по азимуту и вертикали, не более, угл. мин',
					value: '3'
				},
				{
					name: 'Номинальное напряжение питания постоянного тока, В',
					value: '24'
				},
				{
					name: 'Потребляемая мощность, не более, Вт.',
					value: '200'
				},
				{
					name: 'Общие габаритно-установочные размеры в рабочем положении, не более, мм:',
					value: ''
				},
				{
					name: '- высота',
					value: '1664'
				},
				{
					name: '- ширина',
					value: '1050'
				},
				{
					name: '- глубина',
					value: '500'
				},
				{
					name: 'Масса, кг, не более',
					value: '320'
				},
			],

}
  },
  computed: {
  },
  methods: {}
}
</script>

<style scoped>
#ABM820 {
    height: 100%;
    color: white;
}
img#photo{
  margin-top: 13%;
  width: 90%;
}
div #caption{
	color: #78daff;
	opacity: 0.9;
	text-decoration: underline;
}
div#desc{
  width: 100%;
}
div#desc p.text{
  text-align: justify;
}
table{
  table-layout: fixed;
}

</style>
